import { getQueryParamFromLocation } from '../../url/queryParamUtils';
const getMessageIdFromLocation = location => {
  return getQueryParamFromLocation('messageId', location);
};
export default getMessageIdFromLocation;